//import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import {
    getCleaningtasks, getCleaningtypes, getView, getdagstaatremarks
} from "../dbconnector/connector";
import { setErrorMessage, setMessage } from "../tools/errorhandling";
import moment from 'moment';

const DagstaatNode = ({ rights, hotel, hotelid, t, datum }) => {

    const [generalservicestasksarray, setgeneralservicestasksarray] = useState([]);
    const [generalservicesextratimearray, setgeneralservicesextratimearray] = useState([]);
    const [payedtasksarray, setpayedtasksarray] = useState([]);
    const [generalservicestasks, setgeneralservicestasks] = useState([]);
    const [generalservicespayedtasksarray, setgeneralservicespayedtasksarray] = useState([]);
    const [cleaningtypearray, setcleaningtypearray] = useState([]);
    const [cleaningtypearrayAD, setcleaningtypearrayAD] = useState([]);
    const [CleaningTypes, setCleaningTypes] = useState({});
    const [dagstaten, setDagstaten] = useState([]);
    const [dagstaten_payedtasks, setDagstaten_payedtasks] = useState([]);
    const [dagstaten_comments, setDagstaten_comments] = useState([]);
    const [dnd_remarks, setDnd_Remarks] = useState([]);
    const [dagstaten_commentsarray, setDagstaten_commentsarray] = useState([]);
    const [dagstaten_actualshoursarray, setdagstaten_actualshoursArray] = useState([]);




    useEffect(() => {

        if (hotelid !== null && datum !== null) {

            GetDagStaten();
            GetRemarks();
            GetDagStaten_payedtasks();
            Getgeneralservicestasks();
            Get_comments_assignments();
        }
    }, [hotelid, datum]);

    useEffect(() => {
        if (generalservicestasks.length > 0) {
            const types = generalservicestasks
            const array = []
            setpayedtasksarray([]);
            setgeneralservicespayedtasksarray([]);
            setgeneralservicestasksarray([]);
            setgeneralservicesextratimearray([]);
            types.forEach((item, index) => {
                ////console.log("type", item)
                let aantal = 0
                if (dagstaten_payedtasks.length > 0) {
                    dagstaten_payedtasks.forEach((taak, index) => {
                        if (taak.cleaningtype_Id !== -1) {
                            if (taak.multiple !== "{}") {
                                let multipletasks = JSON.parse(taak.multiple)
                                const filteredkeys = Object.keys(multipletasks)
                                filteredkeys.forEach((key) => {
                                    if (item.Id === Number(key)) {
                                        aantal = Number(multipletasks[key]) + aantal
                                    }
                                })
                            }
                            else if (taak.tasks !== "") {
                                if (item.Id === Number(taak.tasks)) {
                                    aantal = 1 + aantal
                                }
                            }
                        }
                    })
                }
                if (item.AD === 0) {
                    setpayedtasksarray(pre => [...pre,
                    <tr >
                        <td className="dagstaat_celborderL" width="225">{item.taskDescription}</td>
                        <td className="dagstaat_celborderR" width="425">{aantal}</td>
                    </tr>

                    ])
                }
                if (item.AD === 1) {
                    setgeneralservicespayedtasksarray(pre => [...pre,
                    <tr>
                        <td className="dagstaat_celborderL" width="225">{item.taskDescription}</td>
                        <td className="dagstaat_celborderR" width="425">{aantal}</td>
                    </tr>

                    ])
                }
            })
            let adaantal = 0
            let aduren = 0
            types.forEach((item, index) => {
                if (dagstaten_payedtasks.length > 0) {
                    dagstaten_payedtasks.forEach((taak, index) => {
                        if (taak.cleaningtype_Id === -1) {
                            if (taak.multiple !== "{}") {
                                let multipletasks = JSON.parse(taak.multiple)
                                const filteredkeys = Object.keys(multipletasks)
                                filteredkeys.forEach((key) => {
                                    if (item.Id === Number(key)) {
                                        adaantal = Number(multipletasks[key]) + adaantal
                                    }
                                })
                            }
                            else if (taak.tasks !== "") {
                                if (item.Id === Number(taak.tasks)) {
                                    adaantal = 1 + adaantal
                                }
                            }
                            if (taak.extratime > 0) {
                                aduren = aduren + taak.extratime
                            }
                        }
                    })
                }
            })
            setgeneralservicestasksarray(pre => [...pre,
            <tr >
                <td className="dagstaat_celborderL">Algemene dienst - extra taken</td>
                <td className="dagstaat_celborderR">{adaantal}</td>
            </tr>
            ])

            // setgeneralservicesextratimearray(pre => [...pre,
            // <table cellspacing="0" cellpadding="0" class="dagstaat_subtable" width="650">
            //     <tr key="headertabled0" id="headertabled" >
            //         <td className="dagstaat_celborderTopLine">&nbsp;</td>
            //         <td className="dagstaat_celborderTopLine">Uren</td>
            //     </tr>

            //     <tr >
            //         <td className="dagstaat_celborderL">Algemene dienst - uren</td>
            //         <td className="dagstaat_celborderR">{aduren / 60}</td>
            //     </tr>
            // </table>

            // ])

        }

    }, [generalservicestasks, dagstaten_payedtasks]);

    useEffect(() => {
        setDagstaten_commentsarray([]);
        let comments = "<li>Geen opmerkingen van cleaners</li>"
        if (dagstaten_comments.length > 0) {

            ////console.log("dagstaten_comments: ", dagstaten_comments)
            const types = dagstaten_comments
            comments = "";
            types.forEach((item, index) => {
                if (item.description.length > 0) {
                    comments = comments + "<li>" + item.roomnumber + " : " + item.description + "</li>"
                } else {
                    comments = comments + "<li>" + item.roomnumber + "</li>"
                }

            })

        }
        document.getElementById("opmerkingen").innerHTML = "<ul>" + comments + "</ul>" + "<hr/>"

    }, [dagstaten_comments]);

    useEffect(() => {
        let comments = "<li>Geen 'Do not disturb' opmerkingen</li>"
        if (dnd_remarks.length > 0) {

            ////console.log("dagstaten_comments: ", dagstaten_comments)
            const types = dnd_remarks
            comments = "";
            types.forEach((item, index) => {

                if (item.cleaningtype_type !== -1 && item.DNDRemark !== null && item.DNDRemark.length > 0) {
                    comments = comments + "<li><b>Do not Disturb</b> voor " + item.title + " : " + item.DNDRemark.replaceAll("\n", " ") + "</li>"
                } else if (item.cleaningtype_type !== -1 && item.DNDRemark.length === 0) {
                    comments = comments + "<li><b>Do not Disturb</b> voor " + item.title + "</li>"
                } else if (item.cleaningtype_type === -1 && item.description !== null && item.description.length > 0) {
                    comments = comments + "<li><b>Algemene dienst taak</b> : " + item.title + " : " + item.description.replaceAll("\n", " ") + "</li>"
                } else {
                    comments = comments + "<li><b>Algemene dienst taak</b> : " + item.title + "</li>"
                }
            })


        }
        document.getElementById("dnd").innerHTML = "<ul>" + comments + "</ul>" + "<hr/>"
    }, [dnd_remarks]);

    useEffect(() => {
        const buildguid = async () => {

            let blijvers = 0;
            let vertrekkers = 0;
            let firstword = t('Aantal ')
            let extrawerk = 0;
            let normwerk = 0;
            setcleaningtypearray([]);
            setcleaningtypearrayAD([]);
            setgeneralservicesextratimearray([]);
            setdagstaten_actualshoursArray([])
            console.log("CleaningTypes length : ", hotel)
            console.log("dagstaten length : ", dagstaten.length)
            if (dagstaten.length > 0) {
                document.getElementById("checkinloadingmessage").style.display = "block";
                document.getElementById("coverAllmessage").style.display = "block";

                //   <tr id="norm1">
                //                             <td colspan="2" class="border">
                //                                 <label class="dagstaat_titleContentBox"><b>{t('Cleaningassignments')}</b></label>
                //                                 <table cellspacing="0" cellpadding="0" border="1" width="650" class="dagstaat_subtable">
                //                                     {cleaningtypearray}
                //                                     <tr>
                //                                         <td colspan="2" className="dagstaat_celborderTopLine"><i>Extra betalende taken</i></td>
                //                                     </tr>
                //                                     {payedtasksarray}
                //                                 </table>
                //                             </td>
                //                         </tr>



                dagstaten.forEach((item, index) => {
                    blijvers = item.blijvers
                    vertrekkers = item.vertrekkers
                    // //console.log("dagstaat : ", item)
                    if (hotel.billingtype === 0) {
                        setcleaningtypearray(pre => [...pre,
                        <tr id="norm1">
                            <td colspan="2" class="border">
                                <label class="dagstaat_titleContentBox"><b>{t('Cleaningassignments')}</b></label>
                                <table cellspacing="0" cellpadding="0" border="1" width="650" class="dagstaat_subtable">
                                    <tr id={"blijvers" + index}>
                                        <td id={"blijvers_0" + index} width="225" className="dagstaat_celborderL">{t('Aantal')} {t('Blijvers')}</td>
                                        <td id={"blijvers_1" + index} width="425" className="dagstaat_celborderR">{item.blijvers}</td>
                                    </tr>
                                    <tr id={"vertrekkers" + index}>
                                        <td id={"Vertrekkers_0" + index} className="dagstaat_celborderL">{t('Aantal')} {t('Vertrekkers')}</td>
                                        <td id={"Vertrekkers_1" + index} className="dagstaat_celborderR">{item.vertrekkers}</td>
                                    </tr>
                                    <tr id={"SpecialRequests" + index}>
                                        <td id={"SpecialRequests_O" + index} className="dagstaat_celborderL">{t('Aantal')} {t('SpecialRequests')}</td>
                                        <td id={"SpecialRequests_1" + index} className="dagstaat_celborderR">{item.specialrequests}</td>
                                    </tr>
                                    <tr id={"DND" + index}>
                                        <td id={"DND_O" + index} className="dagstaat_celborderL">{t('Aantal')} {t('DND')}</td>
                                        <td id={"DND_1" + index} className="dagstaat_celborderR">{item.donotdisturb}</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" className="dagstaat_celborderTopLine"><i>Extra betalende taken</i></td>
                                    </tr>
                                    {payedtasksarray}
                                </table>
                            </td>
                        </tr>
                        ])


                        //   <tr id="norm2">
                        //                             <td colspan="2" class="border">
                        //                                 <label class="dagstaat_titleContentBox"><b>{t('Algemene dienst')}</b></label>
                        //                                 <table cellspacing="0" cellpadding="0" border="1" width="650" class="dagstaat_subtable">
                        //                                     {cleaningtypearrayAD}
                        //                                     <tr>
                        //                                         <td colspan="2" class="dagstaat_celborderTopLine"><i>Extra betalende taken</i></td>
                        //                                     </tr>

                        //                                     {generalservicespayedtasksarray}
                        //                                 </table>
                        //                                 {generalservicesextratimearray}
                        //                             </td>
                        //                         </tr>


                        setcleaningtypearrayAD(pre => [...pre,
                        <tr id="norm2">
                            <td colspan="2" class="border">
                                <label class="dagstaat_titleContentBox"><b>{t('Algemene dienst')}</b></label>
                                <table cellspacing="0" cellpadding="0" border="1" width="650" class="dagstaat_subtable">

                                    <tr id={"algemenedienst" + index}>
                                        <td id={"algemenedienst_0" + index} width="225" className="dagstaat_celborderL">{t('Aantal')} {t('Algemene dienst')}</td>
                                        <td id={"algemenedienst_1" + index} width="425" className="dagstaat_celborderR">{item.algemenedienst}</td>
                                    </tr>
                                    {generalservicespayedtasksarray}
                                </table>
                                <table cellspacing="0" cellpadding="0" class="dagstaat_subtable" width="650">
                                    <tr key="headertabled0" id="headertabled" >
                                        <td className="dagstaat_celborderTopLine">&nbsp;</td>
                                        <td className="dagstaat_celborderTopLine">Uren</td>
                                    </tr>

                                    <tr >
                                        <td className="dagstaat_celborderL">Algemene dienst - uren</td>
                                        <td className="dagstaat_celborderR">{item.algemenedienst_norm / 60}</td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                        ])

                        // setgeneralservicesextratimearray(pre => [...pre,
                        // <table cellspacing="0" cellpadding="0" class="dagstaat_subtable" width="650">
                        //     <tr key="headertabled0" id="headertabled" >
                        //         <td className="dagstaat_celborderTopLine">&nbsp;</td>
                        //         <td className="dagstaat_celborderTopLine">Uren</td>
                        //     </tr>

                        //     <tr >
                        //         <td className="dagstaat_celborderL">Algemene dienst - uren</td>
                        //         <td className="dagstaat_celborderR">{item.algemenedienst_norm / 60}</td>
                        //     </tr>
                        // </table>

                        // ])
                    }

                    if (hotel.billingtype === 1) {
                        // document.getElementById("norm1").style.display = "none";
                        //document.getElementById("norm2").style.display = "none";
                        //document.getElementById("norm0").style.display = "table-row";
                        extrawerk += Number(item.blijvers_timespend)
                        extrawerk += Number(item.vertrekkers_timespend)
                        extrawerk += Number(item.specialrequests_timespend)
                        extrawerk += Number(item.dnd_timespend)
                        extrawerk += Number(item.algemenedienst_timespend)
                        extrawerk += Number(item.flitskamers_timespend)
                        //}else{

                        normwerk += Number(item.blijvers_norm)
                        normwerk += Number(item.vertrekkers_norm)
                        normwerk += Number(item.specialrequests_norm)
                        normwerk += Number(item.dnd_norm)
                        normwerk += Number(item.algemenedienst_norm)
                        normwerk += Number(item.flitskamers_norm)

                        setdagstaten_actualshoursArray(pre => [...pre,
                        <tr id="norm0">
                            <td colspan="2" class="border">
                                <label class="dagstaat_titleContentBox"><b>{t('Actuele gepresteerde uren')}</b></label>
                                <table cellspacing="0" cellpadding="0" border="1" width="650" class="dagstaat_subtable">
                                    <tr id={"Extrauren" + index}>
                                        <td id={"Billingtype_O" + index} className="dagstaat_celborderL">{t('actualhours')}</td>
                                        <td id={"Billingtype_1" + index} className="dagstaat_celborderR">geregistreerd= {formatMinutesToHHMM(extrawerk)}  / norm= {formatMinutesToHHMM(normwerk)} </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                        ])

                    } else {

                        // document.getElementById("norm1").style.display = "table-row";
                        //document.getElementById("norm2").style.display = "table-row";
                        // document.getElementById("norm0").style.display = "none";
                    }


                })
                return true
            }

            return false;
        }
        const test = buildguid().then(res => {
            if (res === true) {
                document.getElementById("checkinloadingmessage").style.display = "none";
                document.getElementById("coverAllmessage").style.display = "none";

            } else {

                document.getElementById("checkinloadingmessage").style.display = "block";
                document.getElementById("coverAllmessage").style.display = "block";
            }
        }
        )
    }, [dagstaten]);



    const GetDagStaten = async () => {
        if (hotelid) {
            const fields = '["hotel_id", "creationdate"]';
            const values = `[${hotelid}, "${datum}"]`;
            setDagstaten([])
            await getView("dagstaten", fields, values).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setDagstaten(body)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }

            })
        }
    }

    const GetRemarks = async () => {
        if (hotelid) {
            setDnd_Remarks([])
            await getdagstaatremarks(datum, hotelid).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        //console.log("remarks", body.assignments)
                        setDnd_Remarks(body.assignments)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }

            })
        }
    }


    const GetDagStaten_payedtasks = async () => {
        if (hotel.Hotel_ID) {
            setDagstaten_payedtasks([])
            const fields = '["hotel_id", "creationdate"]';
            const values = `[${hotelid}, "${datum}"]`;
            await getView("dagstaten_hotel_day_payedtasks", fields, values).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setDagstaten_payedtasks(body)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
        }
    }

    const Getgeneralservicestasks = async () => {
        if (hotel.Hotel_ID) {
            await getCleaningtasks(hotel.Hotel_ID, 1).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setgeneralservicestasks(body.items)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }

            })
        }
    }

    const Getcleaningtypes = async () => {
        if (hotel.Hotel_ID) {
            await getCleaningtypes(hotel.Hotel_ID).then(res => {
                if (res.status === 200) {
                    res.json().then(body => {
                        setCleaningTypes(body.items)
                    })
                } else {
                    setErrorMessage(res.statusText, "failed to refresh cleaningtypes")
                }
            })
        }
    }

    const Get_comments_assignments = () => {
        if (hotel.Hotel_ID) {
            setDagstaten_comments([])
            const fields = '["hotel_id", "creationdate"]';
            const values = `[${hotelid}, "${datum}"]`;
            ////console.log("fields: ", fields)
            ////console.log("values: ", values)
            getView("comments_assigments", fields, values).then(res => {
                if (res.status === 200) {

                    res.json().then(body => {
                        setDagstaten_comments(body)
                        //console.log("setDagstaten_comments", body)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }

            })
        }
    }
    const formatMinutesToHHMM = (totalMinutes) => {
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        // Pad with leading zeros if necessary
        const paddedHours = String(hours).padStart(2, '0');
        const paddedMinutes = String(minutes).padStart(2, '0');

        return `${paddedHours}u${paddedMinutes}min`;
    };
    const senddagstaat = () => {
        // const input = document.getElementById('roosterform');
        //////console.log(input)
        // html2canvas(input).then((canvas) => {
        //     const imgData = canvas.toDataURL('image/png');
        //     const pdf = new jsPDF();
        //     pdf.addImage(imgData, 'JPEG', 0, 0);
        //     // pdf.output('dataurlnewwindow');
        //     pdf.save("download.pdf");
        // })
        ////console.log("height :", document.getElementById('printcanvas').clientHeight)
        ////console.log("width :", document.getElementById('printcanvas').clientWidth)

        // htmlToImage.toPng(document.getElementById('printcanvas'), { quality: 1 })
        //     .then(function (dataUrl) {
        //         var link = document.createElement('a');
        //         link.download = 'my-image-name.jpeg';
        //         const pdf = new jsPDF("p", "mm", "a4");

        //         var width = pdf.internal.pageSize.getWidth();
        //         var height = pdf.internal.pageSize.getHeight();
        //         if (document.getElementById('printcanvas').clientHeight > 891) {
        //             width = 0
        //         }
        //         pdf.addImage(dataUrl, 'PNG', 0, 0, width, height);
        //         pdf.save("download.pdf");
        //     });
    }
    return (
        <>
            <form id="roosterform" >
                <div id="printcanvasll" className="printcanvas">
                    <table cellspacing="0" cellpadding="0" border="0" width="700" id="printcanvas" className='dagstaat_table'>
                        <tr>
                            <td>
                                <img class="dagstaat_logo" width="120" height="109" />
                            </td>
                            <td class="dagstaat_title">
                                {t('DAGSTAAT')}
                            </td>
                        </tr>
                        <tr>
                            <td class="dagstaat_celborderL">
                                {t('Naam Hotel')}
                            </td>
                            <td class="dagstaat_celborderR">
                                {hotel.Name}
                            </td>
                        </tr>
                        <tr>
                            <td class="dagstaat_celborderL">
                                {t('Datum')}
                            </td>
                            <td class="dagstaat_celborderR">
                                {moment(new Date(datum).toLocaleDateString('en-CA')).format("DD-MMM-YYYY")}
                            </td>
                        </tr>
                        <tr><td colspan="2">&nbsp;</td></tr>
                        {dagstaten_actualshoursarray}
                        {cleaningtypearray}
                        <tr><td colspan="2">&nbsp;</td></tr>
                        {cleaningtypearrayAD}
                        <tr><td colspan="2" className="dagstaat_celborderTopLine">Opmerkingen</td></tr>
                        <tr><td colspan="2">
                            <div className="dagstaat_div_opmerkingen" border="1" id="alleopmerkingen">
                                <div id="dnd">

                                </div>
                                <textarea className="dagstaat_textarea" border="1" id="opmerkingen_manueel">
                                    "voeg hier opmerkingen toe"
                                </textarea>
                            </div>
                        </td></tr>
                        <tr><td colspan="2" className="dagstaat_celborderTopLine">Technische gebreken</td></tr>
                        <tr><td colspan="2">
                            <div className="dagstaat_div_opmerkingen" border="1" id="allegebreken">
                                <div id="opmerkingen">

                                </div>
                                <textarea className="dagstaat_textarea" border="1" id="technischegebreken_manueel">
                                    "voeg hier technische gebreken toe"
                                </textarea>
                            </div></td></tr>

                        <tr><td colspan="2">
                            Indien u niet binnen 24u op deze dagstaat antwoordt, wordt deze automatisch als goedgekeurd beschouwd.
                        </td></tr>
                    </table>

                </div>

                {/* <div id="printcanvas" className="printcanvas">
                    <div key="headertabled0" id="headertabled" className="dagstaat_table" >
                        <img className="dagstaat_logo"></img>
                        <div className="dagstaat_title">{t('DAGSTAAT')}</div>
                        <div className="dagstaat_celborderL">{t('Naam Hotel')}</div><div className="dagstaat_celborderR">{hotel.Name}</div>
                        <div className="dagstaat_celborderL">{t('Datum')}</div><div className="dagstaat_celborderR">{moment(new Date(datum).toLocaleDateString('en-CA')).format("DD-MMM-YYYY")}</div>
                    </div>
                    <div className='dagstaat_groupbox'>
                         <label className='dagstaat_titleContentBox'>{t('Cleaningassignments')}</label>

                    {cleaningtypearray}
                    <div key="headertabled0" id="headertabled" className="dagstaat_tablerow_2" >
                        <div className="dagstaat_celborderTopLine">Extra betalende taken</div>
                    </div>
                    {payedtasksarray}
                    </div>
                    <div className='dagstaat_groupbox'>
                         <label className='dagstaat_titleContentBox'>{t('Algemene dienst')}</label>
                    {cleaningtypearrayAD}

                    <div key="headertabled0" id="headertabled" className="dagstaat_tablerow_2" >
                        <div className="dagstaat_celborderTopLine">Extra betalende taken</div>
                    </div>

                    {generalservicespayedtasksarray}
</div>

                    {generalservicesextratimearray}

                    <div key="headertabled0" id="headertabled" className="dagstaat_tablerow_2" >
                        <div className="dagstaat_celborderTopLine">Technische gebreken</div>
                        <div>
                            <textarea  className="dagstaat_textarea">Geen technische gebreken
                            </textarea></div>

                    </div>

                    <div key="headertabled0" id="headertabled" className="dagstaat_tablerow_2" >
                        <div className="dagstaat_celborderTopLine">Opmerkingen</div>
                        <div style={dagstaten_commentsarray.length > 0 ? { display: 'none' } : { display: 'block' }}>
                            <textarea  className="dagstaat_textarea">Geen opmerkingen</textarea></div>
                        {dagstaten_commentsarray}
                    </div>

                    <div key="headertabled0" id="headertabled" className="dagstaat_tablerow" >
                        <div className="dagstaat_celborderTopLine">&nbsp;</div><div className="dagstaat_celborderTopLine">&nbsp;</div>
                    </div>

                    <div key="headertabled0" id="headertabled" className="dagstaat_tablerow_3" >
                        Indien u niet binnen 24u op deze dagstaat antwoordt, wordt deze automatisch als goedgekeurd beschouwd.

                    </div>
                </div> */}
            </form>
        </>
    );
}


export default DagstaatNode;
